import React, { useState, useEffect, useRef, useCallback } from 'react';
import PrimaryButton from '../../components/ui/PrimaryButton';

function FinalDataTextArea({ finalData, setInterruptions, nodes, setNodes, addEdge, edges, setEdges }) {
    const textAreaRef = useRef(null);
    const [value, setValue] = useState();

    useEffect(() => {
        const data = JSON.stringify(finalData, null, 2)
        setValue(data)
    }, [finalData])

    useEffect(() => {
        textAreaRef.current.style.height = 'auto';
        textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }, [value]);

    function removeTrailingCommas(jsonString) {
        jsonString = jsonString.replace(/,\s*([\]}])/g, "$1");
        return jsonString;
    }

    const onChangeHandler = (event) => {

        setValue(removeTrailingCommas(event.target.value));
        event.target.style.height = 'auto';
        event.target.style.height = `${event.target.scrollHeight}px`;
    };

    const transformData_with_DFS_layout = (data) => {
        const output = [];
        const botResponses = data.bot_responses;
        let x = -426;
        let depthY = [174]; // y-coordinate for each depth level

        // Add start node
        output.push({
            id: "start-node",
            next: data.start_node,
            type: "startNode",
            position: { x, y: depthY[0] },
            data: { name: "Start" },
            width: 54,
            height: 40,
            selected: false,
            positionAbsolute: { x, y: depthY[0] },
            dragging: false,
        });

        depthY[0] -= 30;

        // DFS function
        const dfs = (id, depth) => {
            const botResponse = botResponses[id];
            x = depth * 350;

            // Initialize y-coordinate for this depth level if not already done
            if (depthY[depth] === undefined) {
                depthY[depth] = 174;
            }

            // Add bot message node
            output.push({
                id,
                type: "botMsgNode",
                position: { x, y: depthY[depth] },
                data: botResponse.data,
                prev: botResponse.prev,
                message: { "en": botResponse.message["en"].join(";"), "hi": botResponse.message["hi"].join(";") },
                user_inputs: botResponse.user_inputs.map(usr_inp => { return { ...usr_inp, input: usr_inp.input.join(";") } }),
                interruptions: botResponse.interruptions,
                specific_interruptions: botResponse.specific_interruptions,
                width: 290,
                height: 100,
                selected: false,
                positionAbsolute: { x, y: depthY[depth] },
                dragging: false,
                default_user_input: botResponse.default_user_input,
            });

            botResponse.user_inputs.forEach((userInput, index) => {
                // Capture current state with a closure
                ((x, y, id) => {
                    output.push({
                        id: userInput.id,
                        type: "userMsgNode",
                        position: { x: 0, y: (100 + 60 * index) },
                        data: { parentNodeId: id },
                        parentNode: id,
                        draggable: false,
                        width: 231,
                        height: 60,
                        selected: false,
                    });
                })(x, depthY[depth], id);

                // Recursively call DFS for next nodes
                if (userInput.next) {
                    dfs(userInput.next, depth + 1);
                }
            });

            // Increment y-coordinate for this depth level
            depthY[depth] += 350;
        };

        // Call DFS for start node
        dfs(data.start_node, 0);

        return output;
    };

    const transformData = (data) => {
        const output = [];
        const botResponses = data.bot_responses;
        const intermediate_start_and_stop_nodes = data.intermediate_start_and_stop_nodes;
        let x = -426;
        let y = 174;




        // Add start node
        output.push({
            id: "start-node",
            next: data.start_node,
            type: "startNode",
            position: { x, y },
            data: { name: "Start" },
            width: 54,
            height: 40,
            selected: false,
            positionAbsolute: { x, y },
            dragging: false,
        });

        y -= 30;

        // Iterate over bot responses
        for (const id in botResponses) {
            const botResponse = botResponses[id];
            x += 350;

            // Add bot message node
            output.push({
                id,
                type: "botMsgNode",
                position: { x, y },
                data: botResponse.data,
                prev: botResponse.prev,
                message: { "en": botResponse.message["en"].join(";"), "hi": botResponse.message["hi"].join(";") },
                user_inputs: botResponse.user_inputs.map(usr_inp => { return { ...usr_inp, input: usr_inp.input.join(";") } }),
                interruptions: botResponse.interruptions,
                specific_interruptions: botResponse.specific_interruptions,
                width: 290,
                height: 100,
                selected: false,
                positionAbsolute: { x, y },
                dragging: false,
                default_user_input: botResponse.default_user_input,
            });


            // eslint-disable-next-line no-loop-func
            botResponse.user_inputs.forEach((userInput, index) => {
                // Capture current state with a closure
                ((x, y, id) => {
                    output.push({
                        id: userInput.id,
                        type: "userMsgNode",
                        position: { x: 0, y: (145 + 50 * index) }
                        ,
                        data: { parentNodeId: id },
                        parentNode: id,
                        draggable: false,
                        width: 231,
                        height: 60,
                        selected: false,
                    });
                })(x, y, id);
            });

        }

        y += 350;
        for (const id in intermediate_start_and_stop_nodes) {
            x += 350;
            const node = intermediate_start_and_stop_nodes[id];
            if (node.type === "startNode") {
                output.push({
                    id,
                    type: node.type,
                    position: { x, y },
                    data: node.data,
                    prev: node.prev,
                    next: node.next,
                });
            } else if (node.type === "stopNode") {
                output.push({
                    id,
                    type: node.type,
                    position: { x, y },
                    data: node.data,
                    prev: node.prev,
                    next: node.next,
                });
            }

        }

        return output;
    };



    const onClickHandler = () => {
        try {
          const parsed = JSON.parse(value);
          const convertedInterruptions = parsed["interruptions"].map(
            (interruption) => {
              return {
                ...interruption,
                input: interruption.input.join(";"),
                message: {
                  ...interruption.message,
                  en: interruption.message.en.join(";"),
                  hi: interruption.message.hi.join(";"),
                },
              };
            }
          );
          setInterruptions(convertedInterruptions);

          const transformedData = transformData(parsed);
          setNodes(transformedData);
          setEdges([]);
          transformedData.forEach((node, index) => {
            if (node.type !== "botMsgNode") {
              setEdges((eds) => {
                //const sourceNode = nodes.find(nd => nd.id === params.source)
                //const targetNode = nodes.find(nd => nd.id === params.target)
                //const parentNodeId = nodes.find(nd => nd.id === params.source).parentNode
                //if (sourceNode.type === 'startNode') {
                //    setNodes((nds) => {
                //        return [
                //            ...nds.map(nd => nd.id === sourceNode.id ? {
                //                ...nd,
                //                "next": params.target,
                //            }
                //                : nd.id === targetNode.id ? { ...nd, prev: params.source } : nd),
                //        ]
                //    })
                //}
                //else if (sourceNode.type === 'userMsgNode' && targetNode.type !== 'stopNode') {
                //    setNodes((nds) => {
                //        return [
                //            ...nds.map(nd => nd.id === parentNodeId ? {
                //                ...nd, user_inputs: nd.user_inputs.map(usr_inp => usr_inp.id === params.source ? {
                //                    ...usr_inp,
                //                    "next": params.target,
                //                } : usr_inp)
                //            } : nd.id === targetNode.id ? { ...nd, prev: params.source } : nd),
                //        ]
                //    })
                //}
                //else if (sourceNode.type === 'userMsgNode' && targetNode.type === 'stopNode') {
                //    setNodes((nds) => {
                //        return [
                //            ...nds.map(nd => nd.id === parentNodeId ? {
                //                ...nd, user_inputs: nd.user_inputs.map(usr_inp => usr_inp.id === params.source ? {
                //                    ...usr_inp,
                //                    "next": "destination",
                //                } : usr_inp)
                //            } : nd.id === targetNode.id ? { ...nd, prev: params.source } : nd),
                //        ]
                //    })
                //}
                if (node.type === "startNode") {
                  return addEdge(
                    {
                      source: node.id,
                      target: node.next,
                      sourceHandle: "start",
                      targetHandle: null,
                    },
                    eds
                  );
                }
                if (node.type === "stopNode") {
                  return addEdge(
                    {
                      source: node.prev,
                      target: node.id,
                      sourceHandle: null,
                      targetHandle: "stop",
                    },
                    eds
                  );
                }
                if (node.type === "userMsgNode") {
                  const parentNode = transformedData.find(
                    (nd) => nd.id === node.parentNode
                  );
                  const targetId = parentNode.user_inputs.find(
                    (usr_inp) => usr_inp.id === node.id
                  ).next;
                  if (targetId === "destination") return eds;
                  return addEdge(
                    {
                      source: node.id,
                      target: parentNode.user_inputs.find(
                        (usr_inp) => usr_inp.id === node.id
                      ).next,
                      sourceHandle: null,
                      targetHandle: null,
                    },
                    eds
                  );
                }
              });
            }
          });
        } catch (e) {}
    };

    return (
        <div className='p-32 text-sm'>
            <PrimaryButton text="Update" onClick={onClickHandler}></PrimaryButton>

            <textarea
                className='w-full rounded-[6px]'
                ref={textAreaRef}
                rows={1}
                value={value}
                onChange={onChangeHandler}
                style={{ overflow: 'hidden' }}
            />
        </div>
    );
}

export default FinalDataTextArea;